export enum TravelDuration {
  SHORT = "2-3",
  MEDIUM = "4-6",
  LONG = "7-10",
  EXTENDED = "11+",
  CUSTOM = "custom",
}

export interface TravelDurationMeta {
  label: string;
  minDays: number;
  maxDays: number | null; // null = open-ended
}

export const TravelDurationMap: Record<TravelDuration, TravelDurationMeta> = {
  [TravelDuration.SHORT]: {
    label: "2–3 Tage",
    minDays: 2,
    maxDays: 3,
  },
  [TravelDuration.MEDIUM]: {
    label: "3–5 Tage",
    minDays: 3,
    maxDays: 5,
  },
  [TravelDuration.LONG]: {
    label: "6–8 Tage",
    minDays: 6,
    maxDays: 8,
  },
  [TravelDuration.EXTENDED]: {
    label: "9-20 Tage",
    minDays: 9,
    maxDays: 20,
  },
  [TravelDuration.CUSTOM]: {
    label: "Eigene Dauer",
    minDays: 1,
    maxDays: null,
  },
};
